import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { User } from '../../models/user.ts';
import type { RootState } from '../store.ts';

export interface UserState {
  user: User | null;
}

const initialState: UserState = {
  user: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;
export const selectUserName = (state: RootState) => state.user.user?.name;
export default userSlice.reducer;
